import { useEffect, useRef } from 'react';

export default function HeroVideo() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const playVideo = () => {
      video.play().catch(() => {
        // Autoplay blocked - poster харагдана
      });
    };

    if (video.readyState >= 3) {
      playVideo();
    } else {
      video.addEventListener('canplay', playVideo, { once: true });
    }

    return () => {
      video.removeEventListener('canplay', playVideo);
    };
  }, []);

  return (
    <section className="video-container relative overflow-hidden bg-[#FFF]">
      <video
        ref={videoRef}
        className="object-cover w-full aspect-[3/4] sm:aspect-[16/9]"
        poster="/media/hero_poster.jpg"
        muted
        playsInline
        loop
        preload="auto"
      >
        <source src="/media/hero_vid.mp4" type="video/mp4" />
      </video>
    </section>
  );
}